class CartDrawer extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener("addtocart", (event) => {
      this.render().then(() => this.show());
    });

    document.addEventListener("cartlink:click", (event) => {
      this.show();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.classList.contains("state--active")) {
        this.hide();
      }
    });

    if (Theme.URLParams.has("cart")) {
      this.show();
    }
  }

  show() {
    document.dispatchEvent(new CustomEvent("cartdrawer:show"));

    if (!this.classList.contains("state--active")) {
      this.opener = document.activeElement;
    }

    requestAnimationFrame(() => {
      this.classList.add("state--active");
      this.querySelector("#cart")?.focus({ preventScroll: true });
    });
  }

  hide() {
    if (!this.classList.contains("state--active")) {
      return;
    }

    this.classList.remove("state--active");

    if (this.opener && this.opener.isConnected) {
      this.opener.focus({ preventScroll: true });
    }

    this.opener = null;
  }

  guard(task) {
    if (this.pending) {
      return Promise.resolve();
    }

    this.pending = true;
    this.classList.add("state--pending");
    this.setAttribute("aria-busy", "true");

    return Promise.resolve()
      .then(task)
      .finally(() => {
        this.pending = false;
        this.classList.remove("state--pending");
        this.removeAttribute("aria-busy");
      });
  }

  changeSubscription(item, element) {
    return this.guard(() => this.updateLine({
      id: item.key,
      quantity: item.quantity,
      selling_plan: element.value
    }, element));
  }

  changeIntoSubscription(item) {
    return this.guard(() => fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify({ items: [item] })
    })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((error) => Promise.reject(error));
      }

      return this.updateLine({ id: item.key, quantity: 0 });
    })
    .catch((error) => {
      console.error("CartDrawer: subscribe failed", error);
    }));
  }

  change(data, element) {
    return this.guard(() => this.updateLine(data, element));
  }

  updateLine(data, element) {
    if (element) {
      element.classList.add('state--loading');
    }

    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(Object.assign({ sections: "cart-drawer" }, data))
    })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((error) => Promise.reject(error));
      }

      return response.json();
    })
    .then((cart) => {
      const sections = cart.sections;

      delete cart.sections;

      document.dispatchEvent(new CustomEvent("cart:change", {
        detail: cart
      }));

      document.dispatchEvent(new CustomEvent("cartchange", {
        detail: cart
      }));

      return this.render(sections);
    })
    .then(() => {
      if (element) {
        element.classList.remove('state--loading');
      }
    })
    .catch(() => {
      if (element) {
        element.classList.remove('state--loading');
      }
    });
  }

  render(sections) {
    function get_new_content(markup) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(markup, "text/html");

      return doc.getElementById("cart");
    }

    const markup = sections && sections["cart-drawer"]
      ? Promise.resolve(sections["cart-drawer"])
      : fetch("/?sections=cart-drawer")
        .then((response) => response.json())
        .then((response) => response["cart-drawer"]);

    return markup
      .then((string) => {
        const hadFocus = this.querySelector("#cart")?.contains(document.activeElement);

        document.getElementById("cart").replaceWith(get_new_content(string));

        if (hadFocus) {
          this.querySelector("#cart")?.focus({ preventScroll: true });
        }
      })
      .then(() => super.connectedCallback());
  }
}

customElements.define("cart-drawer", CartDrawer);
